module.exports = __webpack_public_path__ + "img/account-highlighted.5bcac74e.svg";